import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BrandRequest} from "../models/requests/brand.request";
import { BrandThemeResponse } from "../models/requests/brand-theme.response";

@Injectable({
  providedIn: 'root',
})

export class ThemeV2Service {
  constructor(private httpClient: HttpClient) { }

  getTheme(branding:BrandRequest): Observable<BrandThemeResponse> {
    const requestUrl = environment.apiUrl + environment.treatmentApi + `navigation/get-branding`;
    return this.httpClient.post<BrandThemeResponse>(requestUrl, branding)
      .pipe(
        catchError((error) => {
          return throwError(() => error);
        }),
      );
  }
}
